'use strict';

define('lib/helpers/cleanify',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('cleanify', function (text) {
    if (text) {
      text = text.replace(/&amp/g, '');
      text = text.replace(/[&'$%]/g, '');
      text = Handlebars.Utils.escapeExpression(text);
      text = text.split(' ').join('-').split('_').join('-')
        .split('.')
        .join('-')
        .replace(/[^a-zA-Z0-9\-]+/g, '')
        .toLowerCase();
      return new Handlebars.SafeString(text);
    }
    return '';
  });
});

